import { BaseEntity } from './base-entity';

export class ExternalAuthenticationData implements BaseEntity {
    constructor(public provider: string,
                public ticket: string) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/external-authentication-data.model.ts